export const POST_MESSAGE = {
  // 通用
  TOAST: 'toast',
  CLOSE_DRAWER: 'CLOSE_DRAWER',
  SKIP_TO: 'SKIP_TO',
  MESSAGE_BOX: 'MESSAGE_BOX',
  OPEN_DIALOG: 'OPEN_DIALOG',
  CLOSE_DIALOG: 'CLOSE_DIALOG',
  // 客户管理相关
  REFRESH_LIST: 'REFRESH_LIST',
  CHECK_DETAIL: 'CHECK_DETAIL',
  ADD_CLIENT_SUCCESS: 'ADD_CLIENT_SUCCESS',
  REPEAT_NAME: 'REPEAT_NAME',
  CHECK_BUSINESS_INFO: 'CHECK_BUSINESS_INFO',
  EXPORT_CLIENT_TABLE: 'EXPORT_CLIENT_TABLE',
  SET_REMIND: 'SET_REMIND',
  // 联系人相关
  CHECK_RELATION_DETAIL: 'CHECK_RELATION_DETAIL',
  REFRESH_RELATION_LIST: 'REFRESH_RELATION_LIST',
}

export const RECEIVE_MESSAGE = {
  OPEN_DRAWER: 'OPEN_DRAWER',
  OPEN_RELATION_DRAWER: 'OPEN_RELATION_DRAWER',
  REFRESH_LIST: 'REFRESH_LIST',
  REFRESH_RELATION_LIST: 'REFRESH_RELATION_LIST'
}

export const PROMISE_MESSAGE = 'PROMISE_MESSAGE'
export const PROMISE_MESSAGE_BACK = 'PROMISE_MESSAGE_BACK'
